/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';

import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import { SectionTitle } from 'components';
import styles from '../../comunities-solicitudes-pendiente-list-page-new-onboarding-detalle.module.scss'; // ajusta si lo mueves

interface EncuestaObligatoriaProps {
  solicitudesPendientes: SolicitudPendiente | undefined;
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <div className={styles.detailRow}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{value}</span>
  </div>
);

const formatBool = (v: boolean | undefined | null): string => {
  if (v === true) return I18n.t('Sí');
  if (v === false) return I18n.t('No');
  return '—';
};

const EncuestaObligatoria = ({ solicitudesPendientes }: EncuestaObligatoriaProps) => {
  const encuesta = solicitudesPendientes?.encuesta_obligatoria;


  if (!encuesta) {
    return (
      <div className={styles.containerForm} style={{ padding: '15px 0px' }}>
        <SectionTitle text={I18n.t('Detalle encuesta obligatoria')} />
        <p className={styles.emptyText}>{I18n.t('Encuesta obligatoria no había sido completada')}</p>
      </div>
    );
  }

  const opcionales = (encuesta?.preguntas_opcionales ?? []) as Array<{
    id?: string | number;
    pregunta?: string;
    respuesta?: string;
  }>;

  return (
    <>
      <div className={styles.flex} style={{ padding: '15px 0px 0px 0px' }}>
        <SectionTitle text={I18n.t('Detalle encuesta obligatoria')} />
      </div>

      <div className={styles.containerForm}>
        <div
          style={{
            display: 'flex',
            gap: '2rem',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
          }}
        >


          {/* Columna izquierda: DetailRows */}
          <div style={{ flex: 1, minWidth: '300px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <DetailRow label={I18n.t('¿Vehículo eléctrico?')} value={formatBool(encuesta?.tiene_vehiculo_electrico)} />
            <DetailRow
              label={I18n.t('¿Calefacción eléctrica?')}
              value={formatBool(encuesta?.tiene_calefaccion_electrica)}
            />
            <DetailRow
              label={I18n.t('¿Calentador de agua eléctrico?')}
              value={formatBool(encuesta?.tiene_calentador_de_agua_electrico)}
            />
            <DetailRow label={I18n.t('Código CNAE')} value={encuesta?.codigo_cnae || '—'} />

            {/* Preguntas opcionales */}
            <div style={{ flexBasis: '100%', marginTop: '1rem' }}>
              <SectionTitle text={I18n.t('Preguntas opcionales')} />

              {opcionales.length === 0 ? (
                <p className={styles.emptyText}>{I18n.t('No hay preguntas opcionales')}</p>
              ) : (
                opcionales.map((x, idx) => {
                  const label = x?.pregunta ?? I18n.t('Pregunta');

                  let displayValue = '—';
                  if (typeof x?.respuesta === 'string') {
                    const trimmed = x.respuesta.trim();
                    if (trimmed) displayValue = trimmed;
                  }

                  return <DetailRow key={x?.id ?? `${label}-${idx}`} label={label} value={displayValue} />;
                })
              )}
            </div>
          </div>

          {/* Columna derecha: textarea */}
          <div style={{ flex: 1, minWidth: '300px' }}>
            <div className={styles.observationBlock}>
              <label className={styles.observationLabel} htmlFor="otra-informacion-util-textarea">
                {I18n.t('Otra información útil')}
              </label>
              <textarea
                id="otra-informacion-util-textarea"
                className={styles.observationTextarea}
                value={encuesta?.otra_informacion_util || ''}
                readOnly
              />
            </div>
          </div>


        </div>
      </div>
    </>
  );
};

export default EncuestaObligatoria;
